import React from "react";
import ReactDOM from "react-dom";
import { tableToExcel } from "./excelHelper";

export class ExcelButton extends React.PureComponent<{
  storagekey?: string;
  className?: string;
  style?: React.CSSProperties;
  tableElement: () => React.ReactInstance;
}> {
  downloadAnchorElement: HTMLAnchorElement;

  onExportClick = () => {
    const anchorElement = ReactDOM.findDOMNode(this.downloadAnchorElement)!;
    const tableElement = ReactDOM.findDOMNode(this.props.tableElement())!;
    return tableToExcel(anchorElement, tableElement, "Sheet Name Here");
  };

  getExcelFileName = () => {
    let baseName = this.props.storagekey || "table";
    const date = new Date();
    return `${baseName}-${date.getFullYear()}-${date.getMonth()}-${date.getDate()}-${date.getHours()}-${date.getMinutes()}.xls`;
  };
  render() {
    return (
      <a
        href="#"
        className={this.props.className}
        title="esporta su excel"
        download={this.getExcelFileName()}
        ref={a => (this.downloadAnchorElement = a!)}
        onClick={this.onExportClick}
        style={this.props.style}
      >
        <i className="far fa-file-excel" />
      </a>
    );
  }
}
